<template>
    <section>
        <div class="bg-gradient-to-l from-theme1 to-theme2">
            <div class="container py-6 md:py-3 justify-between items-center flex md:flex-row flex-col gap-3">
                <div
                    class="animate__slow animate__flash animate__infinite text-white text-2xl font-medium leading-7 capitalize flex flex-row">
                    <LoadItemText class="truncate group-hover:overflow-visible">
                        Loading Product.
                    </LoadItemText>
                </div>
                <div
                    class="md:p-2.5 max-md:mt-3 text-white md:text-gray-500 text-xs md:bg-white rounded md:shadow justify-start items-center flex max-md:flex-wrap max-md:gap-3">

                    <div
                        class="animate__slow animate__infinite animate__flash hover:text-violet-600 justify-start mr-2 items-center gap-1 flex leading-none">
                        Product
                        <ChevronRight :size="18" />
                    </div>

                    <div
                        class="animate__slow animate__infinite animate__flash animation-delay-100 hover:text-violet-600 justify-start mr-2 items-center gap-1 flex leading-none">
                        Categories..
                        <ChevronRight :size="18" />
                    </div>

                    <div
                        class="animate__slow animate__infinite animate__flash animation-delay-200 hover:text-violet-600 justify-start mr-2 items-center gap-1 flex leading-none">
                        Series..
                        <ChevronRight :size="18" />
                    </div>

                    <div
                        class="animate__slow animate__infinite animate__flash animation-delay-300 justify-start mr-2 items-center gap-1 flex leading-none max-w-[100px] hover:max-w-full hover:opacity-100 transition-all group opacity-50 capitalize">
                        <p class="truncate group-hover:overflow-visible">
                            Product Name..
                        </p>
                    </div>

                </div>
            </div>
        </div>

        <div class="container py-12">
            <div class="flex max-md:flex-col gap-12">
                <!-- Gallery -->
                <div class="max-w-[320px] mx-auto w-full flex flex-col lg:max-w-sm xl:max-w-md max-md:gap-6 gap-3">
                    <LoadContainer class="h-[320px]" />
                    <div class="max-md:mx-auto grid grid-cols-4 gap-3">
                        <LoadItem v-for="(item, index) in 4"
                            :class="'rounded-md aspect-square animation-delay-' + index + '00'" />
                    </div>
                </div>
                <div class="grow gap-6 flex flex-col">
                    <!-- Bar Price -->
                    <div class="pb-3 border-b flex-wrap gap-3 justify-between items-end flex">
                        <div class="max-sm:order-2 justify-start items-end gap-3 flex flex-wrap">

                            <LoadItemText class="text-lg font-semibold">
                                Loading Price.
                            </LoadItemText>


                        </div>
                        <div
                            class="animate__slow animate__infinite animate__flash max-sm:order-1 px-4 py-2 bg-gradient-to-l from-violet-500 to-blue-500 text-white font-bold leading-tight rounded-full shadow">
                            <div>
                                <span class="text-xs">Calculating..</span>
                            </div>
                        </div>
                    </div>

                    <!-- Bar Detail -->
                    <div class="pb-3">
                        <LoadItemText class="text-gray-600 text-base font-bold">
                            Loading Detail.
                        </LoadItemText>
                        <div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
                            <div v-for="item in 2"
                                class="w-full h-[100px] bg-slate-100 rounded-lg  relative overflow-hidden">
                                <div
                                    class="w-full h-full animate__animated animate__delay-2s animate__infinite animate__fadeOut">
                                    <div
                                        class="bg-gradient-to-l animate__delay-2s from-slate-300 to-transparent content-[''] w-full h-full animate__slow animate__fadeInLeftBig animate__infinite">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Bar Variant -->
                    <div class="pb-3 flex flex-col gap-3">
                        <LoadItem v-for="(item, index) in 3"
                            :class="'w-full max-w-xs h-8 rounded-md animation-delay-' + index + '00'" />
                    </div>

                    <!-- Bar Button -->
                    <div class="pb-3 flex flex-row gap-6">
                        <div v-for="(item, index) in 4"
                            :class="'animate__slow animate__infinite animate__pulse animation-delay-' + (index * 3) + '00'"
                            class="w-full max-w-[100px] h-10 rounded-full content-[''] bg-slate-200">
                        </div>
                    </div>

                    <!-- Bar Desc -->
                    <div class="pb-3">
                        <LoadItemText class="text-gray-600 text-base font-bold ">
                            Loading Desc.
                        </LoadItemText>
                        <LoadContainer class="h-[100px]" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { ChevronRight } from "lucide-vue-next";
import LoadItemText from "@/Components/Skeleton/LoadItemText.vue";
import LoadContainer from "@/Components/Skeleton/LoadContainer.vue";
import LoadItem from "@/Components/Skeleton/LoadItem.vue";
</script>